// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__31Nfl","inner":"Form_inner__2P67V","range":"Form_range__2FENE","name":"Form_name__3U9_d","actions":"Form_actions__3EwbT"};